import React, { useEffect, useState } from 'react';
import { Info } from 'react-feather';
import { CHECKALL, DeliveryComplete, DeliveryProcessing, Notification, OrderComplete, TicketsGenerated } from '../../../Constant';
import { Link } from 'react-router-dom';
import itService from '../../../api/itService';

const Notificationbar = ({ totalNotifications, data }) => {
  const [notificationDropDown, setNotificationDropDown] = useState(false);
  const [notes, setNotes] = useState([])

  const getReleaseNotes = async () => {
    try {
      const res = await itService.get_all_release_notes()
      if (res.status == 200) {
        setNotes(res?.data)
      }
    } catch (error) {
      console.log(error)
    }
  }
  useEffect(() => {
    getReleaseNotes()
  }, [])

  return (
    <li className='onhover-dropdown'>
      <div className='notification-box' onClick={() => setNotificationDropDown(!notificationDropDown)}>
        <Info />
        <span className='badge rounded-pill badge-secondary'>{totalNotifications}</span>
      </div>
      <div className={`notification-dropdown onhover-show-div ${notificationDropDown ? 'active' : ''}`}
        style={{
          maxHeight: '50vh',
          overflowY: 'auto',
        }}
      >
        <h6 className='f-18 mb-0 dropdown-title'>{Notification}</h6>
        <ul>
          <div className="notes-container">
            {/* First show the most recent note (current version) */}
            {notes?.length > 0 && (
              <div className="current-version" style={{
                padding: '20px',
                backgroundColor: '#f8fafc',
                borderLeft: '4px solid #3b82f6',
                borderRadius: '8px',
                marginBottom: '20px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',

              }}>
                <h3 style={{
                  marginTop: 0,
                  marginBottom: '12px',
                  color: '#1e40af',
                  fontSize: '18px',
                  fontWeight: '600'
                }}>
                  Current Version ({notes[0].version})
                </h3>
                <div style={{ whiteSpace: 'pre-line', color: '#1f2937', lineHeight: '1.6' }}>
                  {notes[0].note}
                </div>
                <div style={{
                  marginTop: '12px',
                  fontSize: '13px',
                  color: '#64748b',
                  display: 'flex',
                  justifyContent: 'space-between'
                }}>
                  {/* <span>Updated: {new Date(notes[0].updated_at).toLocaleString()}</span> */}
                  <span>Created: {new Date(notes[0].created_at).toLocaleString()}</span>
                </div>
              </div>
            )}

            {/* Then show older versions */}
            {notes?.length > 1 && (
              <div className="older-versions" style={{ marginTop: '30px' }}>
                <h4 style={{
                  margin: '0 0 15px 0',
                  color: '#64748b',
                  fontSize: '16px',
                  fontWeight: '500',

                }}>
                  Previous Versions
                </h4>

                <ul style={{ padding: 0, listStyle: 'none' }}>
                  {notes.slice(1).map((item, index) => (
                    <li key={index} style={{
                      padding: '15px',
                      backgroundColor: '#fff',
                      borderLeft: '4px solid #e2e8f0',
                      borderRadius: '6px',
                      marginBottom: '12px',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
                    }}>
                      <div style={{ whiteSpace: 'pre-line', color: '#334155', lineHeight: '1.5' }}>
                        {item.note}
                      </div>
                      <div style={{
                        marginTop: '8px',
                        fontSize: '12px',
                        color: '#94a3b8',
                        display: 'flex',
                        justifyContent: 'space-between'
                      }}>
                        <span>Version: {item.version}</span>
                        <span>{new Date(item.created_at).toLocaleString()}</span>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div> 
          {/* <li className='b-l-primary border-4'>
            <p>
              PPE Module Notification <span className='font-danger'>{'10 min.'}</span>
            </p>
          </li>
          <li className='b-l-success border-4'>
            <p>
              Helmet Violation Alert
              <span className='font-success'>{'1 hr'}</span>
            </p>
          </li>
          <li className='b-l-info border-4'>
            <p>
            Helmet Violation Alert
              <span className='font-info'>{'3 hr'}</span>
            </p>
          </li>  */}


          <li>
            {/* <Link to={`${process.env.PUBLIC_URL}/live_alerts/${JSON.parse(localStorage.getItem('role'))}`} className='f-w-700'>
              {CHECKALL}
            </Link> */}
          </li>
        </ul>
      </div>
    </li>
  );
};

export default Notificationbar;